/**
 * @desc AJS compliant router function to handle migration routes
 * @param {angular.$stateProvider} $stateProvider - Angular stateprovider to handle states
 * @return {void}
 */
export function MerchantBulkCreateRouter($stateProvider) {
  $stateProvider
    .state('app.ops-support-merchant-bulk-create', {
      url: '/ops-support/merchant-bulk-create',
      template: '<app-merchant-bulk-create></app-merchant-bulk-create>',
    })
}



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-bulk-create/merchant-bulk-create.router.js